import { required, minValue, number, regex } from "react-admin";

export const TrainingVideoResources = "training-videos";

export const TAG_KEY_OPTIONS = [
  { value: "ring_material", label: "Ring Material", apiUrl: "custom-pricing/ring-materials" },
  { value: "profile", label: "Profile", apiUrl: "custom-pricing/profiles" },
  { value: "weight", label: "Weight", apiUrl: "custom-pricing/weights" },
  { value: "ring_finish", label: "Ring Finish", apiUrl: "custom-pricing/finishes" },
  { value: "second_ring_finish", label: "Second Ring Finish", apiUrl: "custom-pricing/finishes" },
  { value: "sleeve", label: "Sleeve", apiUrl: "custom-pricing/sleeves" },
  { value: "groove_group", label: "Groove Group", apiUrl: "custom-pricing/groove-groups" },
  { value: "inlay_material", label: "Inlay Material", apiUrl: "custom-pricing/inlays" },
  { value: "inlay_finish", label: "Inlay Finish", apiUrl: "custom-pricing/finishes" },
  { value: "inlay_accent", label: "Inlay Accent", apiUrl: "custom-pricing/mga-color-options" },
  { value: "gemstone_arrangement", label: "Gemstone Arrangement", apiUrl: "custom-pricing/gemstone-arrangements" },
  { value: "gemstone_setting", label: "Gemstone Setting", apiUrl: "custom-pricing/gemstone-settings" },
  { value: "gemstone_cut", label: "Gemstone Cut", apiUrl: "custom-pricing/gemstone-cuts" },
  { value: "gemstone_size", label: "Gemstone Size", apiUrl: "custom-pricing/gemstone-dimensions" },
  { value: "gemstone_material", label: "Gemstone Material", apiUrl: "custom-pricing/gemstones" },
  { value: "machine_pattern", label: "Machine Pattern", apiUrl: "custom-pricing/machine-patterns" },
  {
    value: "machine_pattern_cerakote_color",
    label: "Machine Pattern Cerakote Color",
    apiUrl: "custom-pricing/machine-pattern-color-options",
  },
];

export const getTagApiUrl = key =>
  TAG_KEY_OPTIONS.find(option => option.value === key)?.apiUrl || "";

export const createEmptyTagRow = () => ({ key: "", value: "" });

const isTagRow = tag => tag && typeof tag === "object" && "key" in tag && "value" in tag;

export const apiTagsToRows = tags => {
  if (!Array.isArray(tags)) return [];

  return tags.map(tag => {
    if (isTagRow(tag)) {
      return { key: tag.key || "", value: tag.value || "" };
    }

    if (tag && typeof tag === "object") {
      const keys = Object.keys(tag).filter(key => key !== "category" && key !== "name");
      if (keys.length === 1) {
        const key = keys[0];
        return { key, value: tag[key] || "" };
      }

      if (tag.name) {
        return { key: tag.category || "", value: tag.name };
      }
    }

    return createEmptyTagRow();
  });
};

export const rowsToApiTags = rows =>
  (Array.isArray(rows) ? rows : [])
    .map(row => {
      if (isTagRow(row) && row.key && row.value) {
        return { [row.key]: row.value };
      }

      if (row && typeof row === "object") {
        const keys = Object.keys(row).filter(key => key !== "category" && key !== "name");
        if (keys.length === 1 && row[keys[0]]) {
          return { [keys[0]]: row[keys[0]] };
        }
      }

      return null;
    })
    .filter(Boolean);

export const getTagLabel = tag => {
  if (!tag || typeof tag !== "object") return String(tag);

  if (isTagRow(tag)) {
    return tag.key ? `${tag.key}: ${tag.value}` : tag.value;
  }

  if (tag.name && !Object.keys(tag).some(key => TAG_KEY_OPTIONS.some(opt => opt.value === key))) {
    return tag.name;
  }

  const keys = Object.keys(tag).filter(key => key !== "category" && key !== "name");
  if (keys.length === 1) {
    const key = keys[0];
    const option = TAG_KEY_OPTIONS.find(opt => opt.value === key);
    const keyLabel = option ? option.label : key;
    return `${keyLabel}: ${tag[key]}`;
  }

  return JSON.stringify(tag);
};

export const validateTitle = [required(), regex(/.{1,255}/, "Title is required")];
export const validatePriority = [
  required(),
  number("Priority must be a number"),
  minValue(0, "Priority must be 0 or greater"),
];
export const validateVideoPath = [
  required("Please upload a video"),
  regex(/^videos\//, "Video path must start with videos/"),
];
export const validateVietnameseVideoPath = value => {
  if (!value) return undefined;
  return /^videos\//.test(value) ? undefined : "Video path must start with videos/";
};
export const validateTags = value => {
  const rows = apiTagsToRows(value);

  const hasIncomplete = rows.some(
    row =>
      row &&
      (row.key || row.value) &&
      ((row.key && !row.value) || (!row.key && row.value))
  );
  if (hasIncomplete) {
    return "Each tag must have both key and value";
  }

  return undefined;
};
